module.exports = __webpack_public_path__ + "img/zy.4e44f231.jpg";